import { useContext } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import { DatePicker } from "../../../BP2Components";
import InputActions from "../InputActions/InputActions";
import IntlMessages from "../../../../util/IntlMessages";

import "./Inputs.less";
import { getDecorators } from "../../../../util/getDecorators";

const DateInput = ({ item, onStartEdit, onDuplicate, onDelete }) => {
   const { previewMode } = useContext(FormBuilderContext);
   const decoratorMap = getDecorators(item.decorators);

   const required = decoratorMap?.RequiredDecorator?.required ?? false;
   const hide = decoratorMap?.HideFieldDecorator?.hide ?? false;
   const editable = decoratorMap?.EditableDecorator?.edit ?? true;

   if (previewMode && (item.hidden || hide)) return null;

   return (
      <>
         <label htmlFor={item?.name} className="form-builder-input-label">
            {(item.required || required) && <span className="form-builder-input-required">*</span>}
            {item.label}
            {(item.hidden || hide) && (
               <span className="form-builder-input-label-hidden">
                  (<IntlMessages id="form.hiddenField" />)
               </span>
            )}
            :
         </label>
         <div id={item?.name} className="form-builder-input">
            <DatePicker
               placeholder={item.placeholder}
               readOnly={!previewMode}
               onStartEdit={onStartEdit}
               disabled={!editable}
            />

            <InputActions onStartEdit={onStartEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
         </div>
      </>
   );
};

export default DateInput;
